import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class CultureFvScrollAnimation {
  constructor(triggerSelector, targetSelector, options = {}) {
    this.triggerSelector = triggerSelector;
    this.targetSelector = targetSelector;
    this.breakpoint = options.breakpoint || 769;
    this.scrollDistanceVw = options.scrollDistanceVw || 54.1666666667;
    this.widthDecreaseVw = options.widthDecreaseVw || 55.3472222222;
    this.ease = options.ease || "power2.inOut";
    this.trigger = document.querySelector(this.triggerSelector);
    this.target = document.querySelector(this.targetSelector);
    this.animation = null;
    this.matchMedia = null;

    if (!this.trigger || !this.target) return;

    this.init();
  }

  init() {
    this.matchMedia = gsap.matchMedia();

    this.matchMedia.add(`(min-width: ${this.breakpoint}px)`, () => {
      this.createAnimation();

      return () => {
        this.destroyAnimation();
      };
    });
  }

  createAnimation() {
    this.animation = gsap.fromTo(
      this.target,
      {
        width: "100%",
      },
      {
        width: `calc(100% - ${this.widthDecreaseVw}vw)`,
        ease: this.ease,
        scrollTrigger: {
          trigger: this.trigger,
          start: "top bottom",
          end: () => `+=${window.innerWidth * (this.scrollDistanceVw / 100)}`,
          scrub: true,
          invalidateOnRefresh: true,
        },
      },
    );
  }

  destroyAnimation() {
    if (!this.animation) return;

    if (this.animation.scrollTrigger) {
      this.animation.scrollTrigger.kill();
    }

    this.animation.kill();
    this.animation = null;

    gsap.set(this.target, {
      clearProps: "width",
    });
  }

  destroy() {
    this.destroyAnimation();

    if (this.matchMedia) {
      this.matchMedia.revert();
      this.matchMedia = null;
    }
  }
}

export default CultureFvScrollAnimation;
